module.exports = "/Interessant@2x-f81e8428ba77f5cbd7758da64eafa818.png";